import { BehaviorSubject } from 'rxjs';
import Api from 'requestapijs';
import { API_URL, HEADER } from '../config';
import { CompanyService } from './CompanyService';
import {
  ValueaditionEdges,
  ValueaditionQueryResponse,
  ValueaditionQueryVariable,
  valueaditionQuery,
  ValueaditionNodeEdgeMutation,
  AddValueaditionVariable,
  valueaditionMutation,
} from '../components/Valueadition/constants';
import { DateService } from './DateService';

export class ValueaditionService {
  static instance;

  constructor() {
    if (ValueaditionService.instance) {
      return ValueaditionService.instance;
    } else {
      ValueaditionService.instance = this;
    }
    this.onInit();
  }

  onInit() {
    this.companyService?.selectedBussiness$.subscribe((bussiness) => {
      if (!bussiness) return;
      bussiness.type === 'branch'
        ? this.getAll({
            companyId: bussiness.companyId,
            branchId: bussiness.id,
            branchId_Isnull: false,
          })
        : this.getAll({
            companyId: bussiness.id,
            branchId: null,
            branchId_Isnull: true,
          });
    });
  }

  public readonly valueadition$ = new BehaviorSubject<ValueaditionEdges[]>([]);
  companyService = new CompanyService();
  dateService = new DateService();

  getAll({ companyId, branchId, branchId_Isnull }) {
    let variables: any = { companyId, date_Lte: this.dateService?.date$.value };
    if (branchId) {
      variables = {
        ...variables,
        branchId,
      };
    } else {
      variables = {
        ...variables,
        branchId_Isnull,
      };
    }
    const body = {
      query: valueaditionQuery,
      variables,
    };

    Api.post<{ query: string; variables: ValueaditionQueryVariable }>(
      API_URL,
      body,
      HEADER,
    ).subscribe((response) =>
      this.valueadition$.next(
        (response.response as ValueaditionQueryResponse).data.allValueaditions
          .edges,
      ),
    );
  }

  addValueadition(
    data: ValueaditionNodeEdgeMutation,
    onSuccess: (reponse) => void,
    onError: (response) => void,
  ) {
    data.productDetails = data.productDetails?.map((pd) => {
      pd.date = data.date;
      pd.movementForId =
        this.companyService?.selectedBussiness$.value?.type === 'branch'
          ? this.companyService?.selectedBussiness$.getValue()?.id
          : null;
      pd.companyId = this.companyService?.company$.getValue()?.id;
      delete pd.product;
      delete pd.movementFor;
      return pd;
    });

    Api.graphql<AddValueaditionVariable, {}>(
      API_URL,
      {
        input: {
          valueadition: {
            ...data,
            companyId: this.companyService?.company$.getValue()?.id,
            branchId:
              this.companyService?.selectedBussiness$.value?.type === 'branch'
                ? this.companyService?.selectedBussiness$.getValue()?.id
                : null,
          },
        },
      },
      valueaditionMutation,
      HEADER,
      (response) => {
        onSuccess(response);
        this.onInit();
      },
      (error) => onError(error),
    );
  }
}
